module.exports = __webpack_public_path__ + "img/love-god-logo-sm.04495a18.png";